import { render, staticRenderFns } from "./AdminItemElement.vue?vue&type=template&id=42819280&scoped=true"
import script from "./AdminItemElement.vue?vue&type=script&lang=js"
export * from "./AdminItemElement.vue?vue&type=script&lang=js"
import style0 from "./AdminItemElement.vue?vue&type=style&index=0&id=42819280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42819280",
  null
  
)

export default component.exports